var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSetupTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33333 1.55556C1.90378 1.55556 1.55556 1.90378 1.55556 2.33333V7.77778V11.6667C1.55556 12.0962 1.90378 12.4444 2.33333 12.4444H11.6667C12.0962 12.4444 12.4444 12.0962 12.4444 11.6667V7.77778V2.33333C12.4444 1.90378 12.0962 1.55556 11.6667 1.55556H2.33333ZM0 2.33333C0 1.04467 1.04467 0 2.33333 0H11.6667C12.9554 0 14 1.04467 14 2.33333V7.77778V11.6667C14 12.9554 12.9554 14 11.6667 14H2.33333C1.04467 14 0 12.9554 0 11.6667V7.77778V2.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSetupTick);
export default __webpack_public_path__ + "static/media/profile-setup-tick.e2623a8ee60f8b645baf6400769373bc.svg";
export { ForwardRef as ReactComponent };